<ng-template>
  <div class="autocomplete-panel" role="listbox" [ngClass]="_classList" #panel>
    <ng-content></ng-content>
  </div>
</ng-template>